/**
 * Returns the applicable tax rate based on the given amount.
 *
 * - If the amount is less than or equal to ₹7500, a 5% tax rate applies.
 * - If the amount is greater than ₹7500, an 18% tax rate applies.
 *
 * @param {number} amount - The room charge amount.
 * @returns {number} The applicable tax rate (either 5 or 18).
 */
export const getTaxRateForAmount = (amount) => {
  return amount <= 7500 ? 5 : 18;
};
